import React, { ReactNode, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
interface INavigationHistoryContext {
  history: string[];
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const NavigationHistoryContext =
  React.createContext<INavigationHistoryContext>(
    {} as INavigationHistoryContext,
  );
export const useNavigationHistory = () => useContext(NavigationHistoryContext);
type NavigationHistoryProviderProps = {
  children: ReactNode;
};
export const NavigationHistoryProvider: React.FC<
  NavigationHistoryProviderProps
> = ({ children }) => {
  const location = useLocation();
  const historyRef = useRef<string[]>([]);
  useEffect(() => {
    historyRef.current.push(location.pathname);
  }, [location]);
  return (
    <NavigationHistoryContext.Provider value={{ history: historyRef.current }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};
